var toPositiveInteger = require('../internals/to-positive-integer');

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/to-offset.js
// module id = 246
// module chunks = 48